import React from "react";
import { ICellRendererParams } from "ag-grid-community";
import { Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { dropdownContainer } from "./styles_vanilla.css";

interface Props {
  params: ICellRendererParams;
}

const EntityStatusCellDropDownRenderer: React.FC<Props> = ({ params }) => {
  return (
    <Flex alignItems="center" justifyContent="space-between" className={dropdownContainer}>
      <Text>{params.value}</Text>
      <Icon data-testid="caret-down" type="caret-down" />
    </Flex>
  );
};

export default EntityStatusCellDropDownRenderer;
